import React from 'react';

const CarouselDetails = ({ data }) => {
	console.log('data', data);
	return (
		<div style={{}}>
			<div
				id='carouselExampleIndicators'
				class='carousel slide'
				data-ride='carousel'>
				<ol class='carousel-indicators'>
					<li
						data-target='#carouselExampleIndicators'
						data-slide-to='0'
						class='active'></li>
					<li data-target='#carouselExampleIndicators' data-slide-to='1'></li>
					<li data-target='#carouselExampleIndicators' data-slide-to='2'></li>
				</ol>
				<div class='carousel-inner'>
					{data.map((l) => {
						return (
							<div class='carousel-item active'>
								<img
									class='d-block w-100'
									src={l}
									alt='First slide'
									style={{ borderRadius: 5, height: 450 }}
								/>
							</div>
						);
					})}
				</div>
				<a
					class='carousel-control-prev'
					href='#carouselExampleIndicators'
					role='button'
					data-slide='prev'>
					<span class='carousel-control-prev-icon' aria-hidden='true'></span>
					<span class='sr-only'>Previous</span>
				</a>
				<a
					class='carousel-control-next'
					href='#carouselExampleIndicators'
					role='button'
					data-slide='next'>
					<span class='carousel-control-next-icon' aria-hidden='true'></span>
					<span class='sr-only'>Next</span>
				</a>
			</div>
		</div>
	);
};

export default CarouselDetails;
